import { Link } from 'react-router-dom';
import type { Movie } from '@/types/media';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col cursor-pointer animate-fade-up"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - ${movie.genres.join(' ')}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-primary-950 text-xs font-bold font-label">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-950/70 text-background-100 text-[11px] font-medium">
          {movie.category === 'movie' ? '电影' : '剧集'}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center text-primary-700">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </span>
      </div>
      <h3 className="mt-3 text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
        {movie.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 truncate">
        {movie.year} · {movie.region} · {movie.genres[0]}
      </p>
    </Link>
  );
}